export default "__VITE_ASSET__DL$cmoIF__"